<template>
  <div class="v-tab-group" @scroll="scroll" ref="input">
    <slot/>
    <div class="slidebar" :style="slidebarStyle">
      <div class="slider" :style="sliderStyle"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: null
    },
    trigger: {
      default: "click",
      validator(value) {
        return ["click", "hover"].includes(value);
      }
    }
  },
  data() {
    return {
      sliderLeft: 0,
      slidebarStyle: {},
      sliderStyle: {}
    };
  },
  methods: {
    scroll(e) {
      let { scrollLeft } = e.target;
      this.slidebarStyle = {
        transform: `translate3d(${scrollLeft}px,0,0)`
      };
      Object.assign(this.sliderStyle, {
        transition: `0ms`,
        transform: `translate3d(${this.sliderLeft - scrollLeft}px,0,0)`
      });
    },
    setValue(tab) {
      if (tab.value != this.value) {
        this.$emit("input", tab.value);
        this.$emit("change", tab);
      }
      this.$emit("select", tab);
    },
    setSliderStyle(tab, duration = 0) {
      if (tab.$el && tab.value === this.value) {
        let { scrollLeft } = this.$el,
          { offsetWidth, offsetLeft } = tab.$el;
        this.sliderStyle = {
          width: `${offsetWidth}px`,
          transition: `${duration}ms`,
          transform: `translate3d(${(this.sliderLeft = offsetLeft) -
            scrollLeft}px,0,0)`
        };
      }
    }
  }
};
</script>

<style lang="less">
.v-tab-group {
  display: flex;
  overflow: auto;
  position: relative;
  white-space: nowrap;
  > .slidebar {
    left: 0px;
    right: 0px;
    bottom: 0px;
    position: absolute;
    background-color: #dddddd;
    > .slider {
      width: 0px;
      bottom: 0px;
      height: 2px;
      visibility: hidden;
      background-color: #3e946a;
    }
  }
  &[slider] {
    > .slidebar {
      > .slider {
        visibility: visible;
      }
    }
  }
  &[type="space-around"] {
    display: flex;
    justify-content: space-around;
  }
}
</style>